export default __webpack_public_path__ + "static/media/mercedes_logo.fa6acecc.svg";